import { Box, Card, Container, Grid, Stack, styled, Tab, Tabs } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { capitalCase } from 'change-case';
import { useLocation } from 'react-router';
import InfiniteScroll from 'react-infinite-scroller';
import ProfilePage from '../../components/common/ProfilePage';
import Page from '../../components/Page';
import {
  ProfileAbout
  // ProfileFollowInfo,
  // ProfileSocialInfo
} from '../../fl-sections/@dashboard/user/profile';
import PendingRequests from '../../components/common/ProfileRightSide/PendingRequests';
import InstituteEditProfile from '../../components/common/InstituteEditDialog';
import Iconify from '../../fl-components/Iconify';
import { getAllFeedsByCreator } from '../../service/feed.service';
import { SET_PERSONAL_FEEDS } from '../../redux/constants';
import { SkeletonFeed } from '../../fl-components/skeleton';
import Feed from '../Feed';

const TabsWrapperStyle = styled('div')(({ theme }) => ({
  zIndex: 9,
  bottom: 0,
  width: '100%',
  display: 'flex',
  position: 'absolute',
  backgroundColor: theme.palette.background.paper,
  borderBottomLeftRadius: '16px',
  borderBottomRightRadius: '16px',
  [theme.breakpoints.up('sm')]: {
    justifyContent: 'center'
  },
  [theme.breakpoints.up('md')]: {
    justifyContent: 'flex-end',
    paddingRight: theme.spacing(3)
  }
}));

export default function InstituteProfile() {
  const selectedOrg = useSelector((state) => state.org.selectedOrg);
  const currentUser = useSelector((state) => state.auth.currentUser);
  const [openModal, setOpenModal] = useState(false);
  const routeState = useLocation();
  // tab value state
  const [currentTab, setCurrentTab] = useState('Feed');
  const [isDataFetching, setIsDataFetching] = useState(false);

  // Feeds data from redux
  const feedList = useSelector((state) => state.feeds.personalFeeds);
  const feedOffset = useSelector((state) => state.feeds.personalFeedOffset);
  const feedHasMore = useSelector((state) => state.feeds.personalFeedHasMore);
  const dispatch = useDispatch();

  const fetchPersonalFeeds = async () => {
    const res = await getAllFeedsByCreator(currentUser.id, feedOffset);
    if (res) {
      dispatch({
        type: SET_PERSONAL_FEEDS,
        payload: {
          feeds: res.results,
          offset: feedOffset + 1
        }
      });
    }
    setIsDataFetching(false);
  };

  useEffect(() => {
    if (feedList === null) fetchPersonalFeeds();
  }, []);

  useEffect(() => {
    if (routeState?.state?.openModal) {
      setOpenModal(true);
    }
  }, [routeState]);

  return (
    <Page title="Profile">
      <Container>
        <Card
          sx={{
            mb: 3,
            height: 280,
            position: 'relative'
          }}
        >
          <ProfilePage userDetail={selectedOrg} />
          <TabsWrapperStyle>
            <Tabs
              allowScrollButtonsMobile
              variant="scrollable"
              scrollButtons="auto"
              value={currentTab}
              onChange={(e, value) => {
                if (value !== 'Edit') setCurrentTab(value);
              }}
              sx={{ maxHeight: '40px', alignItems: 'center' }}
            >
              <Tab
                disableRipple
                iconPosition="start"
                key="Feed"
                value="Feed"
                label={capitalCase('Feed')}
                icon={<Iconify icon="gg:feed" width={20} height={20} />}
              />
              <Tab
                disableRipple
                iconPosition="start"
                key="PendingRequest"
                value="PendingRequest"
                label={capitalCase('Pending Request')}
                icon={<Iconify icon="gg:feed" width={20} height={20} />}
              />
              <Tab
                disableRipple
                key="Edit profile"
                value="Edit"
                iconPosition="start"
                icon={<Iconify icon="ic:round-account-box" width={20} height={20} />}
                label={capitalCase('Edit')}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setOpenModal(true);
                }}
              />
            </Tabs>
          </TabsWrapperStyle>
        </Card>
        <Box>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <Stack spacing={3}>
                {/* <ProfileFollowInfo profile={selectedOrg} /> */}
                {(selectedOrg?.city || selectedOrg?.email) && (
                  <ProfileAbout profile={selectedOrg} />
                )}
                {/* <ProfileSocialInfo profile={selectedOrg} /> */}
              </Stack>
            </Grid>

            <Grid item xs={12} md={8}>
              <Stack spacing={3}>
                {currentTab === 'Feed' && (
                  <InfiniteScroll
                    pageStart={0}
                    loadMore={() => {
                      if (feedHasMore && !isDataFetching) {
                        fetchPersonalFeeds();
                        setIsDataFetching(true);
                      }
                    }}
                    hasMore={feedHasMore}
                    loader={
                      <Box my={4}>
                        <SkeletonFeed />
                      </Box>
                    }
                  >
                    <Feed feedDetails={feedList} />
                  </InfiniteScroll>
                )}
                {currentTab === 'PendingRequest' && <PendingRequests />}
              </Stack>
            </Grid>
          </Grid>
        </Box>
        {openModal && (
          <InstituteEditProfile
            open={openModal}
            handleClose={() => setOpenModal(false)}
            selectedOrg={selectedOrg}
          />
        )}
      </Container>
    </Page>
  );
}
